export default {"src":"https://s.nxtpen.com/larkplayer-campaigns/_next/static/media/line.5ab9f5f7.svg","height":458,"width":2};